import { takeLatest, call, put } from 'redux-saga/effects';
import {
  ADD_AIRPORT_FAILURE,
  ADD_AIRPORT_REQUEST,
  ADD_AIRPORT_SUCCESS,
  APPROVE_AIRPORT_UPDATE_REQUEST,
  DELETE_AIRPORT_REQUEST,
  FETCH_AIRPORTS_REQUEST,
  FETCH_ALL_AIRPORT_REQUEST,
  UPDATE_AIRPORT_REQUEST,
  VIEW_AIRPORT_REQUEST,
} from '../types/airportTypes';
import {
  addAirportEffect,
  airportViewAllEffect,
  airportViewEffect,
  deleteAirportEffect,
  fetchAirportsEffect,
  updateAirportEffect,
  approveAirportEffect,
} from '../Effects/airportEffects';
import {
  addAirportFailure,
  addAirportSuccess,
  approveAirportUpdateFailure,
  approveAirportUpdateSuccess,
  deleteAirportFailure,
  deleteAirportSuccess,
  fetchAirportsFailure,
  fetchAirportsSuccess,
  fetchAllAirportFailure,
  fetchAllAirportRequest,
  fetchAllAirportSuccess,
  updateAirportFailure,
  updateAirportSuccess,
  viewAirportFailure,
  viewAirportSuccess,
} from '../actions/airportActions';
import axiosInstance from '../../instance/AxiosInstance';
function* handleAddAirport(action) {
  console.log('adfasdfasdfasdfasdfasdfads');
  try {
    const response = yield call(addAirportEffect, action.payload);
    yield put({ type: ADD_AIRPORT_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: ADD_AIRPORT_FAILURE, payload: error.message });
  }
}
function* airportsViewAllSaga() {
  try {
    const response = yield call(airportViewAllEffect);
    yield put(fetchAllAirportSuccess(response));
  } catch (error) {
    yield put(fetchAllAirportFailure(error || 'Failed to fetch staff'));
  }
}
function* fetchAirportsSaga(action) {
  try {
    const data = yield call(fetchAirportsEffect, action.payload);

    yield put(fetchAirportsSuccess(data));
  } catch (error) {
    const message = error?.message || 'Error fetching airports';
    yield put(fetchAirportsFailure(message));
  }
}
function* handleDeleteAirport(action) {
  try {
    const airportId = action.payload;
    const response = yield call(deleteAirportEffect, airportId);

    yield put(deleteAirportSuccess(response?.message));
  } catch (error) {
    const message = error?.message || 'Failed to delete airport';
    yield put(deleteAirportFailure(message));
  }
}
function* handleUpdateAirport(action) {
  try {
    const { airportId, airportData } = action.payload;
    const response = yield call(updateAirportEffect, airportId, airportData);
    yield put(updateAirportSuccess(response.message));
  } catch (error) {
    const message = error?.message || 'Failed to update airport';
    yield put(updateAirportFailure(message));
  }
}

function* handleViewAirport(action) {
  try {
    const response = yield call(airportViewEffect, action.payload);
    yield put(viewAirportSuccess(response.data));
  } catch (error) {
    const message = error?.message || 'Failed to fetch airport data';
    yield put(viewAirportFailure(message));
  }
}
const API_BASE_URL = 'http://154.61.173.123:7000';
export const updateAirportApprovalStatusAPI = async (
  airportId,
  approvalStatus
) => {
  const payload = { approval_status: approvalStatus };

  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/airports/approve/${airportId}`,
      payload
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// function* approveAirportUpdateSaga(action) {
//   try {
//     const response = yield call(
//       axiosInstance.put,
//       `/airports/approveairportupdate?airport_id=${action.payload}`
//     );
//     yield put(approveAirportUpdateSuccess(response.data));
//   } catch (error) {
//     yield put(
//       approveAirportUpdateFailure(
//         error.response?.data || "Something went wrong"
//       )
//     );
//   }
// }

function* approveAirportUpdateSaga(action) {
  try {
    const response = yield call(approveAirportEffect, action);

    yield put(approveAirportUpdateSuccess(response));
  } catch (error) {
    yield put(approveAirportUpdateFailure(error || 'Something went wrong'));
  }
}

function* watchAirport() {
  yield takeLatest(FETCH_AIRPORTS_REQUEST, fetchAirportsSaga);
  yield takeLatest(ADD_AIRPORT_REQUEST, handleAddAirport);
  yield takeLatest(DELETE_AIRPORT_REQUEST, handleDeleteAirport);
  yield takeLatest(UPDATE_AIRPORT_REQUEST, handleUpdateAirport);
  yield takeLatest(FETCH_ALL_AIRPORT_REQUEST, airportsViewAllSaga);
  yield takeLatest(VIEW_AIRPORT_REQUEST, handleViewAirport);
  yield takeLatest(APPROVE_AIRPORT_UPDATE_REQUEST, approveAirportUpdateSaga);
}
export default watchAirport;
